import { Link } from "@tanstack/react-router";
import logoAsset from "@/assets/vakkundig-logo.png.asset.json";

export function Logo({
  inverted = false,
  size = "md",
}: {
  inverted?: boolean;
  size?: "md" | "lg";
}) {
  const sizeClass =
    size === "lg"
      ? "h-14 w-auto max-w-[260px] object-contain sm:h-16 sm:max-w-[300px]"
      : "h-12 w-auto max-w-[230px] object-contain sm:h-14 sm:max-w-[260px]";

  return (
    <Link
      to="/"
      className={`inline-flex items-center rounded-lg bg-background px-3 py-2 transition-transform hover:scale-[1.02] ${
        inverted ? "shadow-[0_2px_12px_rgba(0,0,0,0.25)]" : ""
      }`}
      aria-label="Vakkundig Verhuizingen & Transport — home"
    >
      <img src={logoAsset.url} alt="Vakkundig Verhuizingen & Transport" className={sizeClass} />
    </Link>
  );
}
